import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { MessageService } from '@core/errors/messages-service';
import { RecoveryCode } from '@core/interfaces';
import { CopyService } from '@fuse/services/copier.service';
import { User } from '@sentry/angular';
import { chain } from 'lodash';

@Component({
  selector: 'recovery-codes',
  templateUrl: './recovery-codes.component.html',
  styleUrls: ['./recovery-codes.component.scss']
})
export class RecoveryCodesComponent {
  @Input()
  public me: User;

  @Input()
  public isNew: boolean;

  @Input()
  public isGenerate: boolean;

  @Input()
  public recoveryCodes: RecoveryCode[];

  @ViewChild('downloadRecoveryCodes', { read: ElementRef, static: true })
  public downloadRecoveryCodesButton: ElementRef;

  constructor(
    private readonly messageService: MessageService,
    private readonly fuseCopierService: CopyService
  ) { }

  public copyRecoveryCodes(): void {
    const value = chain(this.recoveryCodes)
      .filter({ status: 'CURRENT_ACTIVE' })
      .map('plainTextCode')
      .join('; ')
      .value();

    this.fuseCopierService.copyText(value);
    this.messageService.success('PROFILE.DIALOGS.EDIT_MFA.RECOVERY_CODES.COPIED', {});
  }
}
